import {post, request} from '.';
import * as Sentry from '@sentry/react';

//TODO: Replace with Api.js
export const getSchoolsAndTerms = async (args, dispatch) => {
    const endpoint = `School/GetSchoolTerms`;
    const data = await request(endpoint);

    const filteredData = data.map((o) => {
        return {
            ...o,
            terms: o.terms.filter((p) => p.openPublic)
        };
    });

    dispatch({type: 'ADD_SCHOOLS', payload: filteredData});
};

export const getDepartmentsBySchool = async (args, dispatch) => {
    const {schoolID, termSchoolID} = args;

    const endpoint = `Department/Get?termSchoolID=${termSchoolID}`;
    const data = await request(endpoint);

    dispatch({
        type: 'ADD_DEPARTMENTS',
        payload: {
            schoolID,
            departments: data
        }
    });
};

export const getInstructorsBySchoolAndTerm = async (args, dispatch) => {
    const {schoolID, termSchoolID} = args;

    const endpoint = `Instructor/TimetableFilter?schoolID=${schoolID}&termSchoolID=${termSchoolID}`;
    const data = await request(endpoint);

    dispatch({
        type: 'ADD_INSTRUCTORS',
        payload: {
            schoolID,
            termSchoolID,
            instructors: data
        }
    });
};

export const getSetsByDepartmentID = async (args, dispatch) => {
    const {departmentID, termSchoolID} = args;

    const endpoint = `Set/Get?departmentID=${departmentID}&termSchoolID=${termSchoolID}`;
    const data = await request(endpoint);

    dispatch({
        type: 'ADD_SETS',
        payload: {
            departmentID,
            termSchoolID,
            sets: data
        }
    });
};

export const getInstructorTimetable = async (args, dispatch) => {
    const {instructorID, termSchoolID} = args;

    const endpoint = `Timetable/Instructor?instructorID=${instructorID}&termSchoolID=${termSchoolID}`;
    const data = await request(endpoint);

    dispatch({
        type: 'ADD_TIMETABLE',
        payload: {
            id: `${instructorID}_${termSchoolID}`,
            timetable: data
        }
    });
};

export const getSetTimetable = async (args, dispatch) => {
    const {setID, termSchoolID} = args;

    const endpoint = `Timetable/Set?setID=${setID}&termSchoolID=${termSchoolID}`;
    const data = await request(endpoint);

    dispatch({
        type: 'ADD_TIMETABLE',
        payload: {
            id: `${setID}_${termSchoolID}`,
            timetable: data
        }
    });
};

export const getExamSchedules = async (args, dispatch) => {
    const {termSchoolID} = args;

    const endpoint = `Exam/GetExamSchedules?termSchoolID=${termSchoolID}`;
    const data = await request(endpoint);

    dispatch({
        type: 'ADD_EXAM_SCHEDULES',
        payload: {
            termSchoolID,
            examSchedules: data
        }
    });
};

const logEmptyTimetables = (args) => {
    const {id, termSchoolID, timetableType} = args;

    Sentry.captureException(new Error('Invalid Timetable Id'), (scope) => {
        scope.setContext('data', {
            termSchoolId: termSchoolID,
            timetableId: id,
            timetableType: timetableType
        });

        return scope;
    });
};

export const logUserAction = async (action: string, termSchoolId: number = null, timetableId: number = null, timetableType: string = null) => {
    try {
        await post('log', {
            action,
            termSchoolId: termSchoolId,
            timetableId: timetableId,
            timetableType: timetableType
        });
    } catch (error) {
        Sentry.captureException(error);
    }
};
